// extracted by mini-css-extract-plugin
module.exports = {"totals":"CartCard-styles-module--totals--1pB56","subtotal":"CartCard-styles-module--subtotal--3FlCq","warrantyLink":"CartCard-styles-module--warranty-link--eywiY"};